<div class="file-menu-wrap">
  <button class="pxl-menu-btn file-btn" (click)="toggle()" [disabled]="isSpectator" [class.disabled]="isSpectator" [title]="isSpectator ? 'Viewer mode: File menu is disabled' : 'File'">
    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"/><polyline points="13 2 13 9 20 9"/></svg>
    File
  </button>

  <div class="file-dropdown" *ngIf="isOpen" (click)="$event.stopPropagation()">
    <div class="menu-group-label">Project</div>
    <button class="menu-item" (click)="openNewProject()" [disabled]="collabSvc.isInRoom$.value" [title]="collabSvc.isInRoom$.value ? 'Leave the collab room first to create a new project' : 'Create a new project'">
      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 5v14M5 12h14"/></svg>
      New Project
      <span *ngIf="collabSvc.isInRoom$.value" style="font-size:9px;opacity:0.5;margin-left:4px">🔒</span>
    </button>
    <button class="menu-item" (click)="openRecentModal()" [disabled]="collabSvc.isInRoom$.value" [title]="collabSvc.isInRoom$.value ? 'Leave the collab room first to switch projects' : 'Recent Projects'">
      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
      Recent Projects
      <span *ngIf="collabSvc.isInRoom$.value" style="font-size:9px;opacity:0.5;margin-left:4px">🔒</span>
    </button>
    <label class="menu-item" [class.disabled]="collabSvc.isInRoom$.value" [title]="collabSvc.isInRoom$.value ? 'Leave the collab room first to open a file' : 'Open a .pxlvd file'">
      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"/></svg>
      Open .pxlvd
      <span *ngIf="collabSvc.isInRoom$.value" style="font-size:9px;opacity:0.5;margin-left:4px">🔒</span>
      <input type="file" id="pxlvd-import" accept=".pxlvd,.json" (change)="importProject($event)" style="display:none" [disabled]="collabSvc.isInRoom$.value">
    </label>
    <button class="menu-item"
      [disabled]="collabSvc.isInRoom$.value && !collabSvc.can('saveCanvas')"
      [title]="(collabSvc.isInRoom$.value && !collabSvc.can('saveCanvas')) ? 'Admin has disabled saves for members in this room' : 'Save project'"
      (click)="saveRequested.emit(); close()">
      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"/><polyline points="17 21 17 13 7 13 7 21"/><polyline points="7 3 7 8 15 8"/></svg>
      Save <kbd>Ctrl+S</kbd>
    </button>

    <div class="menu-separator"></div>
    <div class="menu-group-label">Export</div>
    <button class="menu-item" (click)="openExport('spritesheet')">
      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/></svg>
      Spritesheet PNG
    </button>
    <button class="menu-item" (click)="openExport('gif')">
      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="2" width="20" height="20" rx="2.18"/><line x1="7" y1="2" x2="7" y2="22"/><line x1="17" y1="2" x2="17" y2="22"/><line x1="2" y1="12" x2="22" y2="12"/></svg>
      Animated GIF
    </button>
    <button class="menu-item" (click)="openExport('image')">
      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="9" cy="9" r="2"/><path d="M21 15l-5-5L5 21"/></svg>
      Image
    </button>
    <button class="menu-item" (click)="openExport('video')">
      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="23 7 16 12 23 17 23 7"/><rect x="1" y="5" width="15" height="14" rx="2"/></svg>
      Video
    </button>
    <button class="menu-item" (click)="exportPxlvd()">
      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
      Download Project
    </button>
  </div>

  <div class="file-backdrop" *ngIf="isOpen" (click)="close()"></div>
</div>

<!-- Export modal -->
<div class="export-modal-backdrop" *ngIf="showExportModal">
  <div class="export-modal">
    <div class="export-modal-header">
      <span *ngIf="showExportModal === 'spritesheet'">Spritesheet Export</span>
      <span *ngIf="showExportModal === 'gif'">GIF Export</span>
      <span *ngIf="showExportModal === 'image'">Image Export</span>
      <span *ngIf="showExportModal === 'video'">Video Export</span>
      <button (click)="showExportModal = null">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
      </button>
    </div>
    <div class="export-modal-body">
      <ng-container *ngIf="showExportModal === 'spritesheet'">
        <div class="export-row"><label>Columns</label><input type="number" [(ngModel)]="spriteColumns" min="1" max="16" class="pxl-input" style="width:70px;"></div>
        <div class="export-row"><label>Scale</label><select class="pxl-input" [(ngModel)]="spriteScale"><option [value]="1">1× native</option><option [value]="2">2×</option><option [value]="4">4×</option><option [value]="8">8×</option></select></div>
        <button class="pxl-btn pxl-btn-primary" style="margin-top:8px;width:100%" (click)="exportSpritesheet()">
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
          Download PNG
        </button>
      </ng-container>

      <ng-container *ngIf="showExportModal === 'gif'">
        <div class="export-row"><label>FPS</label><input type="number" [(ngModel)]="gifFps" min="1" max="60" class="pxl-input" style="width:70px;"></div>
        <div class="export-row"><label>Scale</label><select class="pxl-input" [(ngModel)]="gifScale"><option [ngValue]="2">2×</option><option [ngValue]="4">4×</option><option [ngValue]="8">8×</option></select></div>
        <div class="export-row export-row-check">
          <label>Alpha</label>
          <label class="export-check-label">
            <input type="checkbox" [(ngModel)]="gifTransparentBackground">
            Transparent background
          </label>
        </div>
        <div class="export-row" *ngIf="!gifTransparentBackground">
          <label>Background</label>
          <input type="color" [(ngModel)]="imageBackgroundColor" class="pxl-input" style="width:64px;padding:2px;">
        </div>
        <div class="export-row export-row-check">
          <label>Dither</label>
          <label class="export-check-label">
            <input type="checkbox" [(ngModel)]="gifDither">
            Pre-quantize (softer gradients, less banding)
          </label>
        </div>
        <div class="export-hint">Encodes in the browser (256 colors per frame). Use PNG sequence for lossless frames.</div>
        <div *ngIf="gifStatusMessage" class="export-status" [class.warning]="gifStatusTone === 'warning'" [class.error]="gifStatusTone === 'error'" [class.success]="gifStatusTone === 'success'">
          {{ gifStatusMessage }}
        </div>
        <div *ngIf="isExporting" class="export-progress" style="margin-top:8px">
          <div class="progress-bar" [style.width.%]="exportProgress"></div>
        </div>
        <div style="display:flex;gap:8px;margin-top:8px;">
          <button class="pxl-btn pxl-btn-primary" style="flex:1" [disabled]="isExporting" (click)="exportGif()">
            {{ isExporting ? 'Encoding ' + exportProgress + '%…' : 'Download GIF' }}
          </button>
          <button class="pxl-btn pxl-btn-secondary" style="flex:1" [disabled]="isExporting" (click)="exportPngSequence()">PNG sequence</button>
        </div>
      </ng-container>

      <ng-container *ngIf="showExportModal === 'image'">
        <div class="export-row"><label>Format</label>
          <select class="pxl-input" [(ngModel)]="imageFormat">
            <option *ngFor="let format of getImageFormats()" [value]="format">{{ format.toUpperCase() }}</option>
          </select>
        </div>
        <div class="export-row"><label>Scale</label>
          <select class="pxl-input" [(ngModel)]="imageScale">
            <option [value]="1">1×</option>
            <option [value]="2">2×</option>
            <option [value]="4">4×</option>
            <option [value]="8">8×</option>
          </select>
        </div>
        <div class="export-row export-row-check">
          <label>Frames</label>
          <label class="export-check-label">
            <input type="checkbox" [(ngModel)]="imageExportAllFrames">
            Export all frames (ZIP)
          </label>
        </div>
        <div class="export-row" *ngIf="imageFormat !== 'jpg'">
          <label>Alpha</label>
          <label class="export-check-label">
            <input type="checkbox" [(ngModel)]="imageTransparentBackground">
            Transparent background
          </label>
        </div>
        <div class="export-row" *ngIf="isImageBackgroundColorVisible()">
          <label>Matte</label>
          <input type="color" [(ngModel)]="imageBackgroundColor" class="pxl-input" style="width:64px;padding:2px;">
        </div>
        <div class="export-row" *ngIf="imageFormat === 'jpg' || imageFormat === 'webp'">
          <label>Quality</label>
          <input class="pxl-input" type="number" min="1" max="100" [(ngModel)]="imageQuality" style="width:72px;">
        </div>
        <div class="export-hint">Default exports current frame. Enable "Export all frames" to bundle every frame in a ZIP.</div>
        <div *ngIf="imageStatusMessage" class="export-status" [class.warning]="imageStatusTone === 'warning'" [class.error]="imageStatusTone === 'error'" [class.success]="imageStatusTone === 'success'">
          {{ imageStatusMessage }}
        </div>
        <div *ngIf="isExporting" class="export-progress" style="margin-top:8px">
          <div class="progress-bar" [style.width.%]="exportProgress"></div>
        </div>
        <button class="pxl-btn pxl-btn-primary" style="margin-top:8px;width:100%" [disabled]="isExporting" (click)="exportImage()">
          {{ isExporting ? 'Exporting ' + exportProgress + '%…' : (imageExportAllFrames ? 'Export Frames' : 'Export Image') }}
        </button>
      </ng-container>

      <ng-container *ngIf="showExportModal === 'video'">
        <div class="export-row"><label>Format</label>
          <select class="pxl-input" [(ngModel)]="videoFormat">
            <option *ngFor="let format of getMediabunnyFormats()" [value]="format">{{ format.toUpperCase() }}</option>
          </select>
        </div>
        <div class="export-row"><label>FPS</label><input type="number" [(ngModel)]="videoFps" min="6" max="60" class="pxl-input" style="width:70px;"></div>
        <div class="export-row"><label>Resolution</label>
          <select class="pxl-input" [(ngModel)]="videoWidth">
            <option *ngFor="let w of videoExportWidths" [value]="w">{{ getVideoResolutionLabel(w) }}</option>
          </select>
        </div>
        <div class="export-hint">Supports MP4, WebM, MOV, and MKV depending on browser codec support.</div>
        <div *ngIf="videoStatusMessage" class="export-status" [class.warning]="videoStatusTone === 'warning'" [class.error]="videoStatusTone === 'error'" [class.success]="videoStatusTone === 'success'">
          {{ videoStatusMessage }}
        </div>
        <div *ngIf="isExporting" class="export-progress" style="margin-top:8px">
          <div class="progress-bar" [style.width.%]="exportProgress"></div>
        </div>
        <div style="display:flex;gap:8px;margin-top:8px;">
          <button class="pxl-btn pxl-btn-secondary" style="flex:1" [disabled]="isExporting" (click)="previewVideo()">
            {{ isExporting ? 'Encoding ' + exportProgress + '%…' : 'Preview' }}
          </button>
          <button class="pxl-btn pxl-btn-primary" style="flex:1" [disabled]="isExporting" (click)="exportVideo()">
            {{ isExporting ? 'Encoding ' + exportProgress + '%…' : 'Export ' + (videoFormat | uppercase) }}
          </button>
        </div>
      </ng-container>
    </div>
  </div>
</div>

<!-- Video preview modal -->
<div class="export-modal-backdrop" *ngIf="showVideoPreview" (click)="closeVideoPreview()">
  <div class="export-modal video-preview-modal" (click)="$event.stopPropagation()">
    <div class="export-modal-header">
      Video Preview
      <button (click)="closeVideoPreview()">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
      </button>
    </div>
    <div class="export-modal-body video-preview-body">
      <div class="video-preview-meta">
        <span class="video-preview-label">Previewing now:</span>
        <div class="video-preview-meta-row">
          <span class="video-preview-name">{{ previewFileName }}</span>
          <button class="pxl-btn pxl-btn-secondary pxl-btn-sm" [disabled]="!previewVideoUrl" (click)="downloadPreviewVideo()">Download</button>
        </div>
      </div>
      <ng-container *ngIf="previewVideoUrl">
        <div class="video-player-shell">
          <video
            #previewVideoEl
            class="video-preview-player"
            [src]="previewVideoUrl"
            [loop]="previewLoop"
            [muted]="previewMuted"
            playsinline
            autoplay
            (loadedmetadata)="onPreviewLoadedMetadata(previewVideoEl)"
            (loadeddata)="onPreviewTimeUpdate(previewVideoEl)"
            (timeupdate)="onPreviewTimeUpdate(previewVideoEl)"
            (play)="onPreviewPlayState(true)"
            (pause)="onPreviewPlayState(false)">
          </video>
          <div class="video-preview-controls">
            <div class="video-preview-time-row">
              <span class="video-preview-time">{{ formatPreviewTime(previewCurrentTime) }}</span>
              <input
                type="range"
                class="video-preview-slider"
                min="0"
                [max]="previewDuration || 0"
                step="0.01"
                [value]="previewCurrentTime"
                (input)="seekPreview($any($event.target).value, previewVideoEl)">
              <span class="video-preview-time">{{ formatPreviewTime(previewDuration) }}</span>
            </div>
            <div class="video-preview-control-row">
              <div class="video-preview-control-group">
                <button class="video-control-btn" (click)="togglePreviewPlayback(previewVideoEl)" title="Play/Pause">
                  <svg *ngIf="!previewIsPlaying" width="12" height="12" viewBox="0 0 24 24" fill="currentColor" stroke="none" aria-hidden="true">
                    <polygon points="8 5 19 12 8 19 8 5"></polygon>
                  </svg>
                  <svg *ngIf="previewIsPlaying" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                    <line x1="9" y1="5" x2="9" y2="19"></line>
                    <line x1="15" y1="5" x2="15" y2="19"></line>
                  </svg>
                </button>
                <button *ngIf="previewHasAudio" class="video-control-btn" (click)="togglePreviewMuted(previewVideoEl)" title="Mute/Unmute">
                  <svg *ngIf="!previewMuted" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                    <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon>
                    <path d="M15 9a5 5 0 0 1 0 6"></path>
                    <path d="M18.5 6.5a9 9 0 0 1 0 11"></path>
                  </svg>
                  <svg *ngIf="previewMuted" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                    <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon>
                    <line x1="23" y1="9" x2="17" y2="15"></line>
                    <line x1="17" y1="9" x2="23" y2="15"></line>
                  </svg>
                </button>
                <div *ngIf="previewHasAudio; else noAudioNote" class="video-preview-volume-wrap">
                  <input
                    type="range"
                    class="video-preview-volume"
                    min="0"
                    max="1"
                    step="0.01"
                    [value]="previewVolume"
                    (input)="setPreviewVolume($any($event.target).value, previewVideoEl)">
                </div>
              </div>
              <div class="video-preview-control-group video-preview-control-group-right">
                <button class="video-control-btn" (click)="togglePreviewLoop(previewVideoEl)" title="Loop">
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                    <polyline points="17 1 21 5 17 9"></polyline>
                    <path d="M3 11V9a4 4 0 0 1 4-4h14"></path>
                    <polyline points="7 23 3 19 7 15"></polyline>
                    <path d="M21 13v2a4 4 0 0 1-4 4H3"></path>
                  </svg>
                  <span>{{ previewLoop ? 'On' : 'Off' }}</span>
                </button>
                <button class="video-control-btn" (click)="togglePreviewFullscreen(previewVideoEl)" title="Fullscreen">
                  <svg *ngIf="!previewIsFullscreen" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                    <polyline points="15 3 21 3 21 9"></polyline>
                    <polyline points="9 21 3 21 3 15"></polyline>
                    <line x1="21" y1="3" x2="14" y2="10"></line>
                    <line x1="3" y1="21" x2="10" y2="14"></line>
                  </svg>
                  <svg *ngIf="previewIsFullscreen" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                    <polyline points="4 14 10 14 10 20"></polyline>
                    <polyline points="20 10 14 10 14 4"></polyline>
                    <line x1="14" y1="10" x2="21" y2="3"></line>
                    <line x1="3" y1="21" x2="10" y2="14"></line>
                  </svg>
                </button>
              </div>
            </div>
          </div>
          <ng-template #noAudioNote>
            <div class="video-preview-note">No audio track</div>
          </ng-template>
        </div>
      </ng-container>
      <div class="video-preview-actions">
        <button class="pxl-btn pxl-btn-secondary" style="width:100%" (click)="closeVideoPreview()">Close Preview</button>
      </div>
    </div>
  </div>
</div>

<!-- ── New Project Modal ── -->
<div class="export-modal-backdrop" *ngIf="showNewModal" (click)="showNewModal=false">
  <div class="export-modal" (click)="$event.stopPropagation()">
    <div class="export-modal-header">
      New Project
      <button (click)="showNewModal=false">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
      </button>
    </div>
    <div class="export-modal-body">
      <div class="export-row">
        <label>Name</label>
        <input class="pxl-input" style="flex:1" [(ngModel)]="newProjectName" placeholder="Untitled Project">
      </div>
      <div class="export-row" style="align-items:flex-start;flex-direction:column;gap:6px">
        <label style="margin-bottom:2px">Canvas Size</label>
        <div class="res-grid">
          <button *ngFor="let r of resPresets" type="button" class="res-option"
            [class.active]="isNewProjectResActive(r)"
            (click)="selectNewProjectRes(r)">
            <span class="res-option-preview">
              <span class="res-option-inner"
                [class.res-option-inner--tall]="newProjectPreviewTall(r)"
                [class.res-option-inner--wide]="!newProjectPreviewTall(r)"
                [style.aspect-ratio]="newProjectPreviewAspect(r)"></span>
            </span>
            <span class="res-label">{{ r.label }}</span>
            <span class="res-dims">{{ newProjectDimLabel(r) }}</span>
          </button>
        </div>
        <div class="new-proj-custom-row" *ngIf="newProjectUseCustom">
          <div class="new-proj-custom-field">
            <label>Width</label>
            <input type="number" class="pxl-input" [(ngModel)]="customW" [min]="CANVAS_DIM_MIN" [max]="CANVAS_DIM_MAX">
          </div>
          <div class="new-proj-custom-field">
            <label>Height</label>
            <input type="number" class="pxl-input" [(ngModel)]="customH" [min]="CANVAS_DIM_MIN" [max]="CANVAS_DIM_MAX">
          </div>
        </div>
      </div>
      <button class="pxl-btn pxl-btn-primary" style="margin-top:4px;width:100%" (click)="confirmNewProject()">
        Create Project
      </button>
    </div>
  </div>
</div>

<!-- ── Recent Projects Modal ── -->
<div class="export-modal-backdrop" *ngIf="showRecentModal" (click)="showRecentModal=false">
  <div class="export-modal recent-modal" (click)="$event.stopPropagation()">
    <div class="export-modal-header">
      Recent Projects
      <button (click)="showRecentModal=false">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
      </button>
    </div>
    <div class="export-modal-body recent-modal-body">
      <div *ngIf="recentLoading" class="recent-empty">Loading…</div>
      <div *ngIf="!recentLoading && recentProjects.length===0" class="recent-empty">No saved projects yet. Use Ctrl+S to save.</div>
      <div *ngFor="let p of recentProjects" class="recent-row-wrap">
        <!-- Rename input shown inline when editing -->
        <div *ngIf="renamingId === p.id" class="recent-rename-row">
          <input class="pxl-input recent-rename-input" [(ngModel)]="renameValue"
            (keydown.enter)="commitRename(p)"
            (keydown.escape)="renamingId=null"
            autofocus>
          <button class="icon-btn accent" (click)="commitRename(p)" title="Save">
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>
          </button>
          <button class="icon-btn" (click)="renamingId=null" title="Cancel">
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
          </button>
        </div>
        <!-- Normal row -->
        <div *ngIf="renamingId !== p.id" class="recent-row" (click)="loadRecentProject(p.id, p.name)">
          <img *ngIf="p.thumbnail" [src]="p.thumbnail" class="recent-thumb-lg" alt="">
          <div *ngIf="!p.thumbnail" class="recent-thumb-lg recent-thumb-placeholder">?</div>
          <div class="recent-info">
            <span class="recent-name">{{ p.name }}</span>
            <span class="recent-date">{{ p.updatedAt | date:'MMM d, y · h:mm a' }}</span>
          </div>
          <div class="recent-actions" (click)="$event.stopPropagation()">
            <button class="icon-btn" (click)="startRename(p)" title="Rename">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
            </button>
            <button class="icon-btn danger" (click)="deleteProject(p)" title="Delete">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6M14 11v6"/><path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/></svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
